import { z } from 'zod';
import { getPasswordStrength, PasswordStrength } from '@optimus-web/core';
import { TextKey } from '@mews-framework/localization';
import { passwordRequirements } from '../../utils';
import { CustomErrorParams, CustomErrorType } from '../CustomErrorType';
import { MAX_INPUT_TEXT_LENGTH } from './constants';

// This regex is taken from zod's v4 email validator, see https://v4.zod.dev/api#emails
const emailRegex = /^(?!\.)(?!.*\.\.)([a-z0-9_'+\-\\.]*)[a-z0-9_+-]@([a-z0-9][a-z0-9\\-]*\.)+[a-z]{2,}$/i;

export const requiredStringSchema = z.string().trim().min(1);
export const emptyStringSchema = z.string().or(z.literal(''));
export const emptyWithLimitSchema = (limit: number = MAX_INPUT_TEXT_LENGTH) => z.string().max(limit).or(z.literal(''));
export const passwordSchema = z
    .string()
    .refine((password) => getPasswordStrength(passwordRequirements, password) === PasswordStrength.Good, {
        params: {
            errorType: CustomErrorType.Other,
            textKey: TextKey.PasswordWeakErrorMessage,
        } satisfies CustomErrorParams,
    });

export const strictEmailSchema = z.string().refine((email) => emailRegex.test(email), {
    params: {
        errorType: CustomErrorType.Other,
        textKey: TextKey.ValidateEmail,
    } satisfies CustomErrorParams,
});

export const exclusionSchema = ({ excludedValues, textKey }: { excludedValues: string[]; textKey: Mews.TextKey }) =>
    z.string().refine((value) => !excludedValues.includes(value), {
        params: {
            errorType: CustomErrorType.Other,
            textKey,
        } satisfies CustomErrorParams,
    });
